import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { ClientLocationUserProfileService } from '../services/client_location_user_profiles.service'
import { LocationUserProfileClientDto } from '../types/api'
import { defaultQueryOptions } from './common'

export const useClientLocationUserProfile = (
  locationName: string,
  lupId: string,
  includes?: string[],
  enabled?: boolean
): UseQueryResult<LocationUserProfileClientDto> => {
  return useQuery<LocationUserProfileClientDto>({
    queryKey: ['clientLocationUserProfile', locationName, lupId, includes],
    queryFn: () => ClientLocationUserProfileService.get(locationName, lupId, includes),
    enabled: enabled ? enabled && !!lupId : !!lupId,
    ...defaultQueryOptions,
  })
}
